import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { Field } from "./statement-field";
import { ACTIVE_TEXT, useActiveRow } from "./statement-item-action";
import { StatementItemActionButton } from "./statement-item-action-button";
import { GRID } from "./statement-layout";
import type { LineItem } from "./statement-schema";

export const LineItemRow = ({
  item,
  heading,
}: {
  item: LineItem;
  heading?: string;
}) => {
  const active = useActiveRow({
    heading,
    line: item.title,
    amount: item.amount,
  });

  return (
    <Stack align="start" gap={0} className="w-full gap-2 py-3.5">
      <Stack
        className="w-full"
        direction="row"
        align="start"
        justify="between"
        gap={4}
      >
        <Stack align="start" gap={0} className="min-w-0 gap-0.5">
          {item.eyebrow && (
            <p className="text-xs text-subtle">{item.eyebrow}</p>
          )}
          <Text
            variant="label"
            className="min-w-0 leading-snug wrap-break-word"
          >
            <span className={cn({ [ACTIVE_TEXT]: active })}>{item.title}</span>
          </Text>
        </Stack>
        <Stack direction="row" align="center" gap={0} className="shrink-0">
          {item.amount && (
            <Text variant="label" className="shrink-0 text-right leading-snug">
              {item.amount}
            </Text>
          )}
          <StatementItemActionButton
            heading={heading}
            line={item.title}
            amount={item.amount}
          />
        </Stack>
      </Stack>

      {item.fields && item.fields.length > 0 && (
        <div className={GRID}>
          {item.fields.map((field, index) => (
            <Field
              key={index}
              metric={field}
              strong={field.strong}
              heading={item.title}
            />
          ))}
        </div>
      )}

      {item.note && <p className="text-sm text-subtle">{item.note}</p>}
    </Stack>
  );
};
